import {useAppContext} from "../../utils/AppContext";
import {nav_en} from '../../assets/texts/en.js';
import Brand from './Brand.js';

const Menu = () => {
    const {
        screenSize,
        handleSectionClick,
        activeSection
    } = useAppContext();

    const menuItem = ({item, index}) => (
        <button 
            className={`text-button-text${screenSize}${activeSection === item.id ? " active" : ""}`}
            key={index} 
            onClick={() => handleSectionClick(item.id)}>
            <span className={`text-button-text${screenSize}`}>{item.title}</span>
        </button>
    );

    return (
        <div className={`menu-container${screenSize}`}>
            {nav_en.menu.map((item, index) => (
                menuItem({item, index})
            ))}
            <Brand/>
        </div>
    );

};

export default Menu;
